<div class="loader">
    <div class="status_indicator"></div>
</div>
